import React from 'react'

function DataNotAvailable() {
    return (
        <div>
           <div className="newsfeed__popularlists__section">
        	<span className="list__title">Data Not Available</span>
        	</div>
        </div>
    )
}

export default DataNotAvailable
